/* eslint-disable react/jsx-one-expression-per-line */
import React, { Component } from 'react';
import slack from 'assets/Slack_Mark.svg';
import github from 'assets/GitHub-Mark-Light-32px.png';
import logo from 'assets/logo.png';
import { sample } from 'lodash';
import { Container } from '../../modules/ui-kit-react/lib';
import style from './style.module.css';

const tips = [
  <span>
    Press <code>p</code> to quickly switch between projects in the current
    tenant.
  </span>,
  <span>
    Press <code>t</code> to quickly switch between tenants.
  </span>
];

class Footer extends Component {
  render() {
    return (
      <div className={style.footerWrap}>
        <div className={style.tip}>{sample(tips)}</div>
        <footer>
          <Container className={style.container}>
            <div>
              <a
                href="https://rvohealth.slack.com/archives/C03SXR1DGHY"
                target="_blank"
                rel="noreferrer noopener"
                className={style.logoLink}
              >
                <img alt="Slack Channel" src={slack} />
                #support-redplatform
              </a>
            </div>
            <div>
              <img className={style.shieldLogo} src={logo} alt="Shield" />
            </div>
            <div>
              <a
                href="https://github.com/rvo-redplatform/shield-ui"
                target="_blank"
                rel="noreferrer noopener"
                className={style.logoLink}
              >
                <img alt="shield-ui" src={github} />
                rvo-redplatform/shield-ui
              </a>
            </div>
          </Container>
        </footer>
      </div>
    );
  }
}

export default Footer;
